import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { CONFIG_ERROR } from './config';

// DEV-AI-015: if the backend address was not configured, show a clear message and do not start the app at all
// (so it can never talk to a backend by accident).
function ConfigError() {
  return (
    <div style={{ fontFamily: 'system-ui, sans-serif', maxWidth: 640, margin: '4rem auto', padding: '0 1.5rem' }}>
      <h1 style={{ fontSize: '1.5rem' }}>casavello is not configured</h1>
      <p>{CONFIG_ERROR}</p>
      <p style={{ color: '#6b7280', fontSize: '0.875rem' }}>This is a setup problem, not something you did. If you are a user, please tell the person who runs this site.</p>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode>{CONFIG_ERROR ? <ConfigError /> : <App />}</React.StrictMode>);
